import { useQuery } from '@tanstack/react-query'
import { gql } from 'graphql-request'
import { gqlClient } from '@/lib/graphql'

export type RepoFileStatus = 'synced' | 'pending' | 'pull_pending' | 'muted'

export interface RepoFile {
  path: string
  status: RepoFileStatus
  directory: string | null
  managed: boolean
}

const PREVIEW = gql`
  query RepoPreview($slug: String!) {
    repoPreview(slug: $slug) {
      path
      status
      directory
      managed
    }
  }
`

// Hits the GitHub API server-side, so only fetch when a slug is selected.
export function useRepoPreview(slug: string | null) {
  return useQuery({
    queryKey: ['repo-preview', slug],
    enabled: !!slug,
    queryFn: async () =>
      (await gqlClient.request<{ repoPreview: RepoFile[] }>(PREVIEW, { slug: slug! })).repoPreview,
  })
}
